module.exports = __webpack_public_path__ + "static/icons/icon-piste-map-0cb5a6eae842040cd27999e3c05ead0a.svg";